/**
 * Shared DefiLlama yields helper.
 *
 * `poolsEnriched?pool=<uuid>` returns the single pool's current snapshot
 * including `apy` (a percent APY). Throws on any failure so the caller can
 * fall back or let `safeFetch` log and skip.
 */
const POOLS_ENRICHED = 'https://yields.llama.fi/poolsEnriched?pool='

export const fetchDefiLlamaApy = async (poolId: string): Promise<number> => {
  const res = await fetch(POOLS_ENRICHED + poolId, {
    headers: { accept: 'application/json' },
    signal: AbortSignal.timeout(8000),
  })
  if (!res.ok) throw new Error(`DefiLlama HTTP ${res.status}`)
  const json = await res.json()
  const apy = json?.data?.[0]?.apy
  if (typeof apy !== 'number' || !Number.isFinite(apy)) {
    throw new Error(`DefiLlama: no apy for pool ${poolId}`)
  }
  return apy
}
